'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import { Big } from 'foundations-components/transitional/components/Big';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FullscreenModal extends Component {
  constructor(props) {
    super(props);
    this.renderHeader = this.renderHeader.bind(this);
  }
  renderHeader() {
    return /*#__PURE__*/_jsx(View, {
      boxShadow: "100",
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-subtle",
      children: /*#__PURE__*/_jsxs(ToolBar, {
        use: "tabs",
        paddingBlock: "400",
        paddingInline: "600",
        children: [/*#__PURE__*/_jsx(ToolBarGroup, {
          children: /*#__PURE__*/_jsx(BackButton, {
            "data-test-id": "fullscreen-modal-back-button",
            children: /*#__PURE__*/_jsx(Button, {
              use: "transparent",
              onClick: this.props.onClose,
              marginInlineStart: "0",
              padding: "0",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ContentComponents.fullscreenModal.back"
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(ToolBarGroup, {
          children: this.props.headerContent
        }), /*#__PURE__*/_jsx(ToolBarGroup, {
          children: this.props.headerButton
        })]
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(Modal, Object.assign({
      use: "fullscreen"
    }, this.props.modalProps, {
      children: /*#__PURE__*/_jsxs(View, {
        display: "flex",
        flexDirection: "column",
        blockSize: "100%",
        children: [this.renderHeader(), /*#__PURE__*/_jsx(View, {
          overflow: "auto",
          flexGrow: 1,
          children: this.props.children
        })]
      })
    }));
  }
}
FullscreenModal.defaultProps = {
  modalProps: {}
};
FullscreenModal.propTypes = {
  headerButton: PropTypes.node,
  headerContent: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  modalProps: PropTypes.object
};
export default FullscreenModal;